/**
 * An absolute URL for a stored Favourite or Blocked URL: "https://" is added unless it
 * already starts with http:// or https://. New Favourites are stored in this form.
 */
export const normalizeUrl = (url: string): string => {
  const trimmedUrl = url.trim();
  if (!trimmedUrl) return trimmedUrl;
  if (/^https?:\/\//i.test(trimmedUrl)) {
    return trimmedUrl;
  }
  return `https://${trimmedUrl}`;
};

/**
 * How a stored Favourite or Blocked URL is shown (BA-55): without a leading http:// or
 * https:// and without one trailing "/". "www." and the path stay. Display only: the
 * stored value is what is written, removed and matched. Blocked URLs stored since BA-59
 * have no scheme, so they show as stored.
 */
export const displayUrl = (url: string): string =>
  url.trim().replace(/^https?:\/\//i, '').replace(/\/$/, '');

/** The host part of a displayUrl: everything before the first "/". */
export const displayHost = (url: string): string => displayUrl(url).split('/')[0];
